namespace TerminalApp {
    export class Infobar {
        info_open_arrivals = document.getElementById("info_open_arrivals");
        info_order_count = document.getElementById("info_order_count");
        info_being_picked = document.getElementById("info_being_picked");
        info_ready_for_pack = document.getElementById("info_ready_for_pack");

        constructor() {


            const updateInfoBar = (counts: number[], stockCounts: { [id: string]: number }, deadlineCounts: { [id: string]: number }) => {
                var readyForPickCount = counts[0];
                var totalOrderCount = counts[1];
                var beeingPickedCount = counts[2];
                var readyPackCount = counts[3];
                var arrivalsCount = counts[4];
                var auditCount = counts[5];
                var refillCount = counts[6];
                var productionCount = counts[7];
                var blockedCount = counts[8];
                this.info_order_count.innerHTML = readyForPickCount + "/" + totalOrderCount;
                this.info_being_picked.innerHTML = beeingPickedCount.toString();
                this.info_ready_for_pack.innerHTML = readyPackCount.toString();
                this.info_open_arrivals.innerHTML = arrivalsCount.toString();

                if (blockedCount > 0) {
                    this.info_ready_for_pack.innerHTML += " (" + blockedCount.toString() + " " + SP.Localize("word_blocked") + ")";
                }

                //for (var id in stockCounts) {
                //    document.querySelectorAll(".stock_count_" + id).forEach(e => {
                //        e.innerHTML = stockCounts[id].toString();
                //    });
                //}

                //for (var id in deadlineCounts) {
                //    document.querySelectorAll(".deadline_count_" + id).forEach(e => {
                //        e.innerHTML = deadlineCounts[id].toString();
                //    });
                //}

                TerminalApp.Homescreen.instance.setAppNumber("app_pick_orders", readyForPickCount);
                TerminalApp.Homescreen.instance.setAppNumber("app_pack_tote_list", readyPackCount, blockedCount);
                TerminalApp.Homescreen.instance.setAppNumber("app_move_stock", refillCount);
                TerminalApp.Homescreen.instance.setAppNumber("app_arrival", arrivalsCount)
                TerminalApp.Homescreen.instance.setAppNumber("app_audit_placement", auditCount)
                TerminalApp.Homescreen.instance.setAppNumber("app_production", productionCount)
                if (TerminalApp.App_Generate_Picklist.instance) TerminalApp.App_Generate_Picklist.instance.updateStockCounts(stockCounts);
                if (TerminalApp.App_Generate_Picklist.instance) TerminalApp.App_Generate_Picklist.instance.updateDeadlineCounts(deadlineCounts);
            }
            hub.on("updateInfoBar", updateInfoBar);



        }
    }
}